export default __webpack_public_path__ + "static/media/ActivationFailedArt.2eaedc8b.svg";